import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITienThuaHocSinhReducer } from "../../reducer-model/category/ITienThuaHocSinhReducer";
import { ITienThuaHocSinhActions } from "../../action-types/category/ITienThuaHocSinhActionType";

const iniState: ITienThuaHocSinhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  tienThuaHocSinhs: [],
  tienThuaHocSinh: undefined,
};

export const tienThuaHocSinhReducer = (
  state: ITienThuaHocSinhReducer = iniState,
  action: ITienThuaHocSinhActions
): ITienThuaHocSinhReducer => {
  switch (action.type) {
    case "TIEN_THUA_HOC_SINH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "TIEN_THUA_HOC_SINH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        tienThuaHocSinhs: action.payload,
      };
    case "TIEN_THUA_HOC_SINH_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "TIEN_THUA_HOC_SINH_LOAD_HOCSINH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "TIEN_THUA_HOC_SINH_LOAD_HOCSINH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        tienThuaHocSinh: action.payload,
      };
    case "TIEN_THUA_HOC_SINH_LOAD_HOCSINH_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };

    default:
      return state;
  }
};
